import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";

import { getTimeByDurationFormat } from "Utils";

import styles from "./CollaboratorSpace.local.scss";

const colors = {
  nonBilliable: "#FFAC62",
  billiable: "#12D2DE",
  realizedHours: "#4695DB",
  remainingHours: "#A5C2DE",
  extraTimeSuccess: "#02AF8E",
  extraTimeWarning: "#EDAE49",
  extraTimeDanger: "#D1495B",
  affectedBudget: "#205483"
};

class CapacityPlaningMonthDetails extends Component {
  render() {
    let { monthState } = this.props;
    return (
      <div>
        <div
          className={classnames("row medium-12", styles.capacity_planing_div)}
          style={{ flexFlow: "nowrap" }}
        >
          <div
            key={1}
            className={classnames(
              "columns medium-4 small-4",
              styles.capacity_planing
            )}
            style={{ border: `1px solid ${colors["remainingHours"]}` }}
          >
            <div className={styles.capacity_planing_label_center}>
              <div> {_("remainingHours")}</div>
              <div className={styles.capacity_planing_value}>
                {" "}
                {monthState["remainingHours"] &&
                monthState["remainingHours"] > 0
                  ? getTimeByDurationFormat(monthState["remainingHours"])
                  : "-"}
              </div>
            </div>
          </div>

          <div
            key={2}
            className={classnames(
              "columns medium-4 small-4",
              styles.capacity_planing
            )}
            style={{ border: `1px solid ${colors["realizedHours"]}` }}
          >
            <div
              className={styles.capacity_planing_label_center}
              style={{ width: "19em" }}
            >
              <div
                style={{
                  margin:
                    monthState["nonBillableHours"] &&
                    monthState["nonBillableHours"] > 0
                      ? "-3% 0% -5% 8%"
                      : "1% 0% -5% 8%"
                }}
              >
                {" "}
                {_("realizedHours")}
              </div>
              <div className={styles.capacity_planing_value}>
                {monthState["realizedHours"] && monthState["realizedHours"] > 0
                  ? getTimeByDurationFormat(monthState["realizedHours"])
                  : "-"}
              </div>
              {monthState["nonBillableHours"] &&
              monthState["nonBillableHours"] > 0 ? (
                <div className={styles.capacity_planing_label}>
                  <div
                    style={{
                      marginTop: "2%",
                      marginLeft: "-4%"
                    }}
                  >
                    {"(dont "}
                    <span style={{ fontWeight: "500" }}>
                      {getTimeByDurationFormat(monthState["nonBillableHours"])}
                    </span>{" "}
                    {_("nonBillableHours")})
                  </div>
                </div>
              ) : (
                "-"
              )}
            </div>
          </div>

          <div
            key={3}
            className={classnames(
              "columns medium-4 small-4",
              styles.capacity_planing
            )}
            style={{
              border: `1px solid ${
                monthState["extraTimeSuccess"]
                  ? colors["extraTimeSuccess"]
                  : monthState["extraTimeWarning"]
                    ? colors["extraTimeWarning"]
                    : colors["extraTimeDanger"]
              }`
            }}
          >
            <div className={styles.capacity_planing_label_center}>
              <div style={{ marginLeft: "13%" }}> {_("extraTime")}</div>
              <div className={styles.capacity_planing_value}>
                {" "}
                {monthState["extraTimeSuccess"]
                  ? getTimeByDurationFormat(
                      Math.abs(monthState["extraTimeSuccess"])
                    )
                  : monthState["extraTimeWarning"]
                    ? getTimeByDurationFormat(
                        Math.abs(monthState["extraTimeWarning"])
                      )
                    : monthState["extraTimeDanger"]
                      ? getTimeByDurationFormat(
                          Math.abs(monthState["extraTimeDanger"])
                        )
                      : "-"}
              </div>
            </div>
          </div>
        </div>
        <div
          className={classnames("row medium-12", styles.capacity_planing_div)}
          style={{ flexFlow: "nowrap", marginTop: "1%" }}
        >
          <div
            key={4}
            className={classnames(
              "columns medium-4 small-4",
              styles.capacity_planing
            )}
            style={{ border: `1px solid ${colors["affectedBudget"]}` }}
          >
            <div className={styles.capacity_planing_label_center}>
              <div> {_("affectedBudget")}</div>
              <div className={styles.capacity_planing_value}>
                {" "}
                {monthState["affectedBudget"] &&
                monthState["affectedBudget"] > 0
                  ? getTimeByDurationFormat(monthState["affectedBudget"])
                  : "-"}
              </div>
            </div>
          </div>
          <div
            key={5}
            className={classnames(
              "columns medium-4 small-4",
              styles.capacity_planing
            )}
            style={{ border: `1px solid ${colors["billiable"]}` }}
          >
            <div className={styles.capacity_planing_label_center}>
              <div> {_("realizedBudget")}</div>
              <div className={styles.capacity_planing_value}>
                {" "}
                {monthState["realizedBudget"] &&
                monthState["realizedBudget"] > 0
                  ? getTimeByDurationFormat(monthState["realizedBudget"])
                  : "-"}
              </div>
            </div>
          </div>

          <div
            key={6}
            className={classnames(
              "columns medium-4 small-4",
              styles.capacity_planing
            )}
            style={{ border: `1px solid ${colors["nonBilliable"]}` }}
          >
            <div className={styles.capacity_planing_label_center}>
              <div style={{ marginLeft: "13%" }}> {_("extraBudget")}</div>
              <div className={styles.capacity_planing_value}>
                {" "}
                {monthState["extraBudget"] && monthState["extraBudget"] < 0
                  ? getTimeByDurationFormat(
                      Math.abs(monthState["extraBudget"].toFixed(2))
                    )
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CapacityPlaningMonthDetails;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CapacityPlaningMonthDetails.js